import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import React, { forwardRef, useEffect } from "react";

gsap.registerPlugin(ScrollTrigger);

const Banner = (props, ref) => {
	let scrollTl = null;

	useEffect(() => {
		scrollTl = gsap.timeline({
			scrollTrigger: {
				trigger: ref.current,
				invalidateOnRefresh: true,
				start: () => `top bottom-=200px`,
				markers: false,
				scrub: false, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
			},
		});

		scrollTl.fromTo(ref.current, { autoAlpha: 0 }, { autoAlpha: 1, duration: 1, ease: "Power2.inOut" }, 0.16);
	});
	return (
		<div className="about-banner" ref={ref}>
			<h1 className="about-banner__heading">Want to be a part of it?</h1>
			<p className="about-banner__description">Keep an eye out for our next survey.</p>
		</div>
	);
};

export default forwardRef(Banner);
